/**
 * Экран входа, вариант «Коммутатор».
 *
 * Слева — название, подпись и лицевая панель коммутатора, справа — форма.
 * Сама форма и логика входа — в LoginForm.
 */
import LoginForm from './LoginForm';
import SwitchFaceplate from './SwitchFaceplate';
import { LogoMark } from '../common/Logo';
import styles from './LoginScreen.module.css';

export default function LoginScreen() {
  return (
    <div className={styles.screen}>
      <section className={styles.panel}>
        <div className={styles.brand}>
          <LogoMark size={56} className={styles.mark} />
          <h1 className={styles.title}>Switch Inspector</h1>
          <p className={styles.lead}>
            {/* Подпись перекликается с панелью ниже: индикаторы портов
                загораются по очереди, как при поднятии линков */}
            Всё, что мигает зелёным, —&nbsp;на&nbsp;учёте
          </p>
        </div>
        <div className={styles.device}>
          <SwitchFaceplate />
        </div>
      </section>

      <main className={styles.side}>
        <LoginForm />
      </main>
    </div>
  );
}
